export class Error {
    code: number;
    message: string;
    additional_message: string;
}

export class Counts {
    currentPage: number;
    maxRowPerPage: number;
    rowOnCurrentPage: number;
    totalPage: number;
    totalRows: number;
}


export class MainStatus {
    active: boolean;
    inactive: boolean;
    deleted: boolean;
}

export class AccountStatus {
    activeAccount: true|false;
    newAccount: true|false;
    inactiveAccount: true|false;
    passwordChange: true|false;
}

export class UserAccountStatus {
    new: true|false;
    active: true|false;
    inactive: true|false;
    deleted: true|false;
}

export class UserPinStatus {
    active: true|false;
    inactive: true|false;
}

export class AdminMiniData {
    userId: number;
    username: number;
    firstName: string;
    lastName: string;
}

export class DocumentStatus {
    new: true|false;
    approved: true|false;
    rejected: true|false;
}